import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NSLoginService } from '../../Clients/NS/Services/NSLogin.service';
import { StorageService } from '../services/storage-service.service';

export const authgaurdGuard: CanActivateFn = (route, state) => {
  const logser = inject(NSLoginService);
  const router = inject(Router);
  const storage = inject(StorageService);
  let menulist = storage.getSession('menulist');
  const targetUrl = state.url.substring(1).toLowerCase();
  if (logser.gettoken()) {
    if (menulist && Array.isArray(menulist)) {
      const isAllowed = menulist.some((m: any) =>
        m.url && (m.url.toLowerCase().includes(targetUrl) || targetUrl.includes(m.url.toLowerCase())) && m.status == 1
      );
      if (isAllowed || targetUrl === "" || targetUrl === "userhome") {
        return true;
      }
    } else {
      return false;
    }
  }

  router.navigateByUrl('/userlogin');
  return false;
};
